import React, { useEffect, useState } from 'react';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import Money_Transfer_Seo from '../../SEO/Money_Transfer_Seo';
import AOS from 'aos';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';

function MoneyTransfer() {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 500);
    }, []);
    useEffect(() => {
        AOS.init({
            duration: 3000,
            easing: 'ease-in-out',
            once: true,
            mirror: false,
        });
    }, []);


    return (
        <>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <Money_Transfer_Seo />
                    <Header />
                    {/* Start Page Banner Area */}
                    <div className="page-banner-area position-relative overflow-hidden" style={{ backgroundImage: 'url(assets/images/hero/hero-image-2.svg)' }}>
                        <div className="container">
                            <div className="page-banner-content">
                                <h1>Money Transfer</h1>
                                <ul>
                                    <li><NavLink to="/">Home</NavLink></li>
                                    <li>Money Transfer</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* End Page Banner Area */}

                    {/* Start Choose Us Area */}
                    <div className="choose-us-area ptb-120 overflow-hidden">
                        <div className="container">
                            <div className="about-top mb-5">
                                <div className="row align-items-center">
                                    <div className="col-lg-7 col-md-7">
                                        <div className="section-heading mb-0">
                                            <span className="sub-title">Fast & Easy way to Send Money</span>
                                            <h2 className="mb-0">Trustworthy Money Transfer Service</h2>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-md-5">
                                        <div className="content">
                                            <p>
                                                Ifepay takes pride in offering fast, dependable, and trustworthy money transfers. With us, you can always expect honest answers, no hidden fees, and complete transparency—you get exactly what you see. Recipients in Nigeria can choose to receive cash or have Nigerian Naira deposited directly into their accounts. We've made payments simple and flexible for you by providing options such as bank transfers and card payments at any of our branches. Choose the method that best suits your needs, and we'll handle the rest.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-md-6">
                                    <div className="choose-items position-relative">
                                        <div className="swiper choose-slide">
                                            <div>
                                                <Swiper
                                                    loop={true}
                                                    spaceBetween={0}
                                                    autoplay={{
                                                        delay: 4500,
                                                        disableOnInteraction: false,
                                                    }}
                                                    speed={1500}
                                                    centeredSlides={true}
                                                    roundLengths={true}
                                                    pagination={{
                                                        el: '.choose-pagination',
                                                        clickable: true,
                                                        bulletClass: 'swiper-pagination-bullet',
                                                        bulletActiveClass: 'swiper-pagination-bullet-active',
                                                    }}
                                                    breakpoints={{
                                                        0: { slidesPerView: 1 },
                                                        768: { slidesPerView: 1 },
                                                        992: { slidesPerView: 1 },
                                                        1200: { slidesPerView: 1 },
                                                        1400: { slidesPerView: 1 },
                                                        1920: { slidesPerView: 1 },
                                                    }}
                                                    modules={[Pagination, Autoplay]}
                                                    className="swiper-wrapper"
                                                >
                                                    <SwiperSlide>
                                                        <div className="swiper-slide">
                                                            <div className="innovation">
                                                                <span><img src="assets/images/about/worldwide-reach.png" alt="image" /></span>
                                                                <h2>Worldwide Reach</h2>
                                                                <p>
                                                                    We transfer money from the United Kingdom to over 200 countries and territories.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                    <SwiperSlide>
                                                        <div className="swiper-slide">
                                                            <div className="innovation">
                                                                <span><img src="assets/images/about/competitive-rates.png" alt="image" /></span>
                                                                <h2>Competitive Rates </h2>
                                                                <p>
                                                                    Our competitive pricing ensures you save more when you choose us over others.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                    <SwiperSlide>
                                                        <div className="swiper-slide">
                                                            <div className="innovation">
                                                                <span><img src="assets/images/about/247-service.png" alt="image" /></span>
                                                                <h2>24/7 Service</h2>
                                                                <p>
                                                                    Our online money transfer service is accessible through our website, dedicated customer support team, and user-friendly mobile app.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                </Swiper>
                                            </div>
                                        </div>
                                        <div className="pagination-btn">
                                            <div className="choose-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="choose-us-image position-relative">
                                        <img className="radius-30" src="assets/images/about/about-image-2.webp" alt="image" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Choose Us Area */}

                    {/* Start About Area */}
                    <div className="about-area two ptb-100">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-md-12">
                                    <div className="about-us-content position-relative">
                                        <div className="section-heading">
                                            <span className="sub-title">Reliable Money Transfer Service </span>
                                            <h2>Money Transfer at your Fingertips</h2>
                                            <p>
                                                We understand that you've worked hard for your money. You deserve a better rate and lower fees, so we make every effort to offer you the best rates while keeping expenses to a minimum.
                                            </p>
                                        </div>
                                        <ul className="check">
                                            <li>
                                                <i className="ri-check-line" />
                                                Send money on the go or start a transfer and pay in-store.
                                            </li>
                                            <li>
                                                <i className="ri-check-line" />
                                                Track your money transfer in real time.
                                            </li>
                                            <li>
                                                <i className="ri-check-line" />
                                                Repeat transfers quickly to friends and family.
                                            </li>
                                        </ul>
                                        <div className="d-flex mt-4">
                                            <NavLink to="#" target="_blank" className="me-3">
                                                <img className="rounded-3" src="assets/images/app/android.png" alt="image" />
                                            </NavLink>
                                            <NavLink to="#" target="_blank">
                                                <img className="rounded-3" src="assets/images/app/apple.png" alt="image" />
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="about-image position-relative">
                                        <img className="radius-30" src="assets/images/about/about-image-4.webp" alt="image" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End About Area */}


                    {/* Start Faq Area */}
                    <div className="faq-area two pb-100">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-5 col-md-5" data-aos-delay={300}>
                                    <div className="section-heading mb-0">
                                        <span className="sub-title">FAQ's</span>
                                        <h2>Frequently Asked Questions</h2>
                                        <p className="mb-5">With a robust suite of products ranging from digital banking and payment processing to wealth management and blockchain applications.</p>
                                        <NavLink to="/general-faq" className="default-btn">Show More <i className="ri-arrow-right-up-line" /></NavLink>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-7" data-aos-delay={300}>
                                    <div className="faq-content">
                                        <div className="accordion" id="accordionShould">
                                            <div className="accordion-item">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse20" aria-expanded="false" aria-controls="collapse20">
                                                    1. Why do you need my documents while registration?
                                                </button>
                                                <div id="collapse20" className="accordion-collapse collapse show" data-bs-parent="#accordionShould">
                                                    <div className="accordion-body">
                                                        <p>
                                                            We are regulated by Financial Conduct Authority in the UK. It is our legal binding to verify your identity as a UK resident.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse21" aria-expanded="false" aria-controls="collapse21">
                                                2. How can I cancel my transfer?
                                                </button>
                                                <div id="collapse21" className="accordion-collapse collapse" data-bs-parent="#accordionShould">
                                                    <div className="accordion-body">
                                                        <p>
                                                            Please call us or email us at earliest possible if you want to cancel your transfer. Transfer paid out to the recipient cannot be cancelled. If you have paid for your transfer and the transfer is not processed yet, then please contact us by phone and we will make necessary arrangements for refunds. We may charge you a small fee as handling/service charge and refund you the balance amount.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse22" aria-expanded="false" aria-controls="collapse22">
                                                    3. Will I get notifications about Transfer status?
                                                </button>
                                                <div id="collapse22" className="accordion-collapse collapse" data-bs-parent="#accordionShould">
                                                    <div className="accordion-body">
                                                        <p>Yes. We send email notifications to keep you informed. You can even view the transfer status by signing in into your web account.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse23" aria-expanded="false" aria-controls="collapse23">
                                                    4. How many recipients I can add?
                                                </button>
                                                <div id="collapse23" className="accordion-collapse collapse" data-bs-parent="#accordionShould">
                                                    <div className="accordion-body">
                                                        <p>
                                                            There is no restriction on the number of recipients you may have on your account.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse24" aria-expanded="false" aria-controls="collapse24">
                                                    5. You asked me to upload one more document; how can I do that?
                                                </button>
                                                <div id="collapse24" className="accordion-collapse collapse" data-bs-parent="#accordionShould">
                                                    <div className="accordion-body">
                                                        <p>Please login in to your account and under My Account you will find document section where you can upload the document.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Faq Area */}

                    {/* Start App Area */}
                    <div className="app-area two pb-100 overflow-hidden">
                        <div className="container">
                            <div className="download-area bg-color-edf1ee radius-30">
                                <div className="row g-4 align-items-center">
                                    <div className="col-lg-6 col-md-12" data-aos-delay={200}>
                                        <div className="app-image">
                                            <img className="radius-30" src="assets/images/app/app-image-5.webp" alt="image" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12" data-aos-delay={200}>
                                        <div className="section-heading mb-0 ms-auto">
                                            <span className="sub-title two bg-color-9edd05 rounded-pill">Download App</span>
                                            <h2>Download And Enjoy The Experience</h2>
                                            <p className="mb-5">
                                                Send money worldwide in seconds with Ifepay app. Enjoy fast transfers, competitive rates, and secure transactions. Track your transfers easily, and all from a user-friendly app.
                                            </p>
                                            <div className="app-btn">
                                                <NavLink to="https://play.google.com/store/apps/details?id=com.remit.IfePay" target="_blank" className="me-3">
                                                    <img className="rounded-3" src="assets/images/app/android.png" alt="image" />
                                                </NavLink>
                                                <NavLink to="https://apps.apple.com/us/app/ifepay/id6744351163" target="_blank">
                                                    <img className="rounded-3" src="assets/images/app/apple.png" alt="image" />
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End App Area */}


                    {/* Footer Section Here */}
                    <Footer />
                </>
            )}
        </>
    );
}

export default MoneyTransfer;
